export default __webpack_public_path__ + "static/media/stop1.1f572584.svg";